module.exports = __webpack_public_path__ + "files/bf4edc5a721e5211f352cd6e8b7fe78a.png";